import { useEffect, useState } from 'react';
import { LogType } from '../../../../Types/Enums';
import { CustomEventSource } from './CustomEventSource';
import LogLine from './LogLine';
import { store } from '../../../../store';
import { StoreI18n, StoreSettings } from '../../../../Types/StoreTypes';

const ACTION_LOGGER_TYPES = [LogType.Audit, LogType.Auth, LogType.Dlp, LogType.Connector, LogType.Scim];

function LogFileDialog(props: {
    data: {
        logType: LogType;
        filename: string;
    } | null;
    title: string;
}) {
    const [events, setEvents] = useState<{ id: number; event: string; lineCount: number; payload: string }[]>([]);

    useEffect(() => {
        if (props.data) {
            const { settings, i18n } = store.getState() as { settings: StoreSettings; i18n: StoreI18n };

            setEvents([]);
            const eventSource = new CustomEventSource(settings.apiBaseUrl + '/log-files/stream', {
                params: {
                    type: props.data.logType as string,
                    fromLine: '-100',
                    filename: props.data.filename,
                },
                headers: {
                    UserLanguage: i18n.selectedLanguage,
                    Provider: localStorage.getItem('loginProvider') ?? 'oidc',
                },
            });

            setTimeout(() => {
                const container = document.getElementById('log-file-display-box');
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            }, 1500);

            eventSource.onmessage = ({ data }) => {
                if (data !== 'ping') {
                    const event = JSON.parse(data);

                    const container = document.getElementById('log-file-display-box');
                    const distanceFromBottom = !container
                        ? 0
                        : container.scrollHeight - container.scrollTop - container.clientHeight;

                    setEvents((prevEvents) => [
                        ...prevEvents.slice(prevEvents.length - 1000, prevEvents.length),
                        event,
                    ]);
                    setTimeout(() => {
                        const target = document.getElementById('bottom-to-scroll-to');
                        // User is not near bottom, don't auto-scroll
                        if (distanceFromBottom > 200) {
                            return;
                        }
                        target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 500);
                }
            };

            eventSource.onerror = (err) => {
                eventSource.close();
            };

            return () => {
                eventSource.close();
            };
        }
    }, [props, props.data]);

    useEffect(() => {
        function onKeyDown(e: any) {
            e.stopPropagation();
        }
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, []);

    return (
        <>
            <div
                id="log-file-display-box"
                className="w-full"
                style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
            >
                {events.map((event, index) => (
                    <LogLine
                        key={index}
                        event={event}
                        isActionLogger={ACTION_LOGGER_TYPES.includes(props.data?.logType as any)}
                    />
                ))}
                <div id="bottom-to-scroll-to"></div>
            </div>
        </>
    );
}

export default LogFileDialog;
